// Utilities
import createServiceAsyncThunk from "../../../utils/reduxUtils/createServiceAsyncThunk";
import createGenericSlice from "../../../utils/reduxUtils/createEntitySlice";

// Service
import { departmentService } from "../../../Api/Services/DepartmentService"; // Importing the department service for API calls

// Types
import { IUserDetailsCommon } from "../../../Types/Common";

// Constants
import { ACTION_NAMES, SLICE_NAMES } from "../../../constants/action";
import { ERROR_MESSAGES } from "../../../constants/error";

/**
 * Async thunk to fetch sub-department list.
 * Dispatches an API call to retrieve the sub-department list.
 */
export const fetchSubDepartmentAsyncThunk = createServiceAsyncThunk<
  { data: Array<IUserDetailsCommon> },
  { id: number }
>(
  ACTION_NAMES.FETCH_SUB_DEPARTMENT_LIST, // Action name
  ({ id }: { id: number }) => departmentService.getSubDepartments(id), // API Call
  ERROR_MESSAGES.SUB_DEPARTMENT_LIST_FETCH_FAILURE // Error Message
);

/**
 * Slice to manage the state of sub-department list details.
 * Includes actions to clear errors and handle async states.
 */
export const subDepartmentListSlice = createGenericSlice<
  { data: Array<IUserDetailsCommon> },
  { id: number }
>(SLICE_NAMES.DEPARTMENT_LIST_SLICE, fetchSubDepartmentAsyncThunk);

export const { clearError: clearSubDepartmentListError } =
  subDepartmentListSlice.actions;

// Export the reducer to be included in the Redux store
export default subDepartmentListSlice.reducer;
